import { BRAND_MARKS, type BrandMarkName } from '@littlebird/canvas';

const brandMarkIcon = (name: BrandMarkName, fill = 'currentColor') => {
  const mark = BRAND_MARKS[name];
  const BrandMarkIcon = ({ className }: { className?: string }) => (
    <svg
      className={className}
      viewBox={mark.viewBox}
      fill={fill}
      role="img"
      aria-label={mark.label}
      xmlns="http://www.w3.org/2000/svg"
    >
      {mark.paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
  BrandMarkIcon.displayName = `BrandMarkIcon(${name})`;
  return BrandMarkIcon;
};

export const NotionIcon = brandMarkIcon('notion');
export const LinearIcon = brandMarkIcon('linear');
export const GithubIcon = brandMarkIcon('github');
// HubSpot's mark is recognised by its orange, so it keeps the brand colour
export const HubspotIcon = brandMarkIcon('hubspot', BRAND_MARKS.hubspot.hex);
export const AsanaIcon = brandMarkIcon('asana');
